/** @format */

import { useMutation, useQuery } from "react-query";
import { PaymentOnlyMethod } from "../components/PaymentMethods";
import axios from "../lib/axios";
import { useGeneralState } from "../state/useGeneralState";

/**
 * Checks if user already has saved details.
 */
export function useSavedDetails({ userProfile, paymentType, countryCode }) {
    const { transactionBaseUrl } = useGeneralState();

    const { data: savedDetails } = useQuery(
        ["saveed-details", userProfile, paymentType, countryCode],
        async () => {
            if (PaymentOnlyMethod.xcel === paymentType) {
                const value = await axios.get(
                    `${transactionBaseUrl}paygate/user/${userProfile}/wallets`
                );

                return (value?.data?.data ?? []).map((i) => i?.walletId ?? "");
            }

            if (PaymentOnlyMethod.card === paymentType) {
                // const mockSavedDetails = {
                //     status: true,
                //     data: [
                //         {
                //             firstName: "Valentine",
                //             lastName: "Obi",
                //             email: "Valobi@xcelapp.com",
                //             address: "",
                //             _id: "66603dcd17c98c7f5b564594",
                //             cvv: "*",
                //             expirationDate: "06 / 25",
                //             cardNumber: "**** **** **** 8947",
                //             createdAt: "2024-06-05T10:28:29.701Z",
                //             updatedAt: "2024-06-05T10:28:29.721Z",
                //             __v: 0,
                //             user: "66603dcd6b873d435c083a01",
                //         },
                //     ],
                // };

                try {
                    const value = await axios.get(
                        `${transactionBaseUrl}paygate/user/${userProfile}/cards`
                    );

                    return value?.data ? value?.data?.data : [];
                } catch (error) {
                    return [];
                }

                // return mockSavedDetails?.data;
            }

            return [];
        }
    );

    return savedDetails;
}

export function useCreateSaveDetails({
    email,
    firstName,
    lastName,
    address,
    town,
    state,
    zipCode,
    paymentMethods,
}) {
    const { transactionBaseUrl } = useGeneralState();

    const createDetails = useMutation(
        async ({
            currentPaymentMethod,
            walletId,
            walletPin = "",
            cvv,
            expirationDate,
            cardNumber,
        }) => {
            let user = null;
            try {
                user = await axios.get(`${transactionBaseUrl}paygate/${email}`);
            } catch (e) {}

            try {
                // if (isEmpty(user?.data?._id) || isNull(user)) {
                //     await axios.post(`${transactionBaseUrl}paygate`, {
                //         email,
                //         firstName,
                //         lastName,
                //         address,
                //         paymentMethods,
                //     });
                // }

                // eslint-disable-next-line eqeqeq
                if (currentPaymentMethod == PaymentOnlyMethod.xcel) {
                    return await axios.post(
                        `${transactionBaseUrl}paygate/add-wallet/${email}`,
                        {
                            walletId,
                            walletPin,
                        }
                    );
                // eslint-disable-next-line eqeqeq
                } else if (currentPaymentMethod == PaymentOnlyMethod.card) {
                    return await axios.post(
                        `${transactionBaseUrl}paygate/add-card/${email}`,
                        {
                            cvv,
                            expirationDate,
                            cardNumber,
                            address,
                            town,
                            state,
                            zipCode,
                        }
                    );
                }
            } catch (e) {
                
            }
        }
    );

    return createDetails;
}
